import React from 'react'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { requireNotNull } from '@shared/pipes/require-not-null'

import {
	RegionalPagesPath,
	regionalPagesProps,
} from '../../../regions/runtime-components/pages-props'
import { LoanNaPokupkuDoma } from '../../../screens/loan-na-pokupku-doma'
import { serverSideResolveCity } from '../../../ssr-resolvers/next-ssr-resolvers'

const PersonalPage: NextPageFC<Empty, PageLayoutOwnProps> = () => LoanNaPokupkuDoma()
const pageProps = requireNotNull(regionalPagesProps[RegionalPagesPath.personalNaPokupkuDoma])
PersonalPage.layout = pageProps.layout
PersonalPage.headProps = pageProps.headProps

export const getServerSideProps = serverSideResolveCity

export default PersonalPage
